import React from 'react';
import AutosizeInput from 'react-input-autosize';
import cx from 'classnames';

import * as Icon from 'components/Icon';

import classes from './SearchInput.module.scss';

interface IProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  className?: string;
}

const SearchInput: React.FC<IProps> = ({ value, placeholder, onChange, className }) => {
  return (
    <div className={cx(classes.wrapper, className)}>
      <label className={classes.wrapperInner}>
        <div className={classes.icon}>
          <Icon.System.Search/>
        </div>
        <AutosizeInput
          {...{ value, placeholder }}
          className={classes.inputWrapper}
          inputClassName={classes.input}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value || '')}
          placeholderIsMinWidth
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
        />
        {!!value && (
          <div className={classes.close} onClick={() => onChange('')}>
            <Icon.System.CrossFilled/>
          </div>
        )}
      </label>
    </div>
  );
};

export default SearchInput;